import { ModalTiteledWindow } from "./modalWindow.js";
import { DateSelect } from "../dateSelect.js";
import { Validator } from "../validator.js";
import { ModalConfirm } from "./modalConfirm.js";
import { ModalSelectPupil } from "./modalSelectPupil.js";

export class ModalEditSmartphoneViolationNote extends ModalTiteledWindow {
   constructor(app, initData, onChanged) {
      super();

      this.setTitle('Handy-Verstoß <span class="help icon-info" selector=".smartphone-violation-info"></span>');

      this.app = app;
      this.dm = app.dm;
      this.onChanged = onChanged;
      this.user = this.dm.getUserSelf();

      const defaults = {
         note: '',
         pupilId: false
      };

      initData.pupilIds = initData.pupilId ? [initData.pupilId] : [];

      this.initData = Object.extend(true, defaults, initData);

      this.elMain = HTMLElement.createFromHTML(`
         <div class="modal-edit-smartphone-violation-note">
            <div class="settings-item info"></div>
            <div class="settings-item pupil">
               <div class="title absent">Schüler: </div>
               <div class="content">
                  <div class="name"></div>
                  <i class="icon-plus"></i>
                  <div class="validation-error-message"></div>
               </div>
            </div>
            <div class="settings-item date">
               <div class="title"><span>Datum: <span class="date-value"></span></span><span class="help icon-info" selector=".day-absence-date"></span></div>
               <div class="content">
                  <div class="validation-error-message"></div>
               </div>
            </div>
            <div class="settings-item note">
               <div class="title">Bemerkung</div>
               <div class="content">
                  <textarea rows="5" type="text" class="txt-note"></textarea>
               </div>
            </div>
            <div class="buttons bottom-bar">
               <i class="btn-delete icon-trash button-circle"></i>
               <i class="btn-save icon-check button-circle"></i>
            </div>
         </div>
      `);

      let editable = this.initData.creatorId === undefined || this.initData.creatorId === this.user.id;
      this.elMain.querySelector('.btn-save').onclick = () => this.save();

      if (!editable || this.initData.creatorId === undefined) {
         this.elMain.querySelector('.btn-delete').classList.add('disabled');
      }
      else {
         this.elMain.querySelector('.btn-delete').onclick = () => this.delete();
      }

      // Datum
      this.dateSelect = new DateSelect({ range: false, onSelect: (from, to) => this.setDate(from, to) });
      this.dateSelect.setEnabled(editable);
      this.elMain.querySelector('.settings-item.date .content').prepend(this.dateSelect.getElement());

      this.elPupilName = this.elMain.querySelector('.settings-item.pupil .name');
      this.elMain.querySelector('.settings-item.pupil .icon-plus').onclick = () => {
         if (this.initData.classes.length > 0) {
            let pupilIds = this.dm.getClass(this.initData.classes[0]).pupils;
            new ModalSelectPupil({list: pupilIds}, (ids) => this.setPupils(ids), this.dm);
         }
      }

      this.elNote = this.elMain.querySelector('.settings-item.note textarea');
      this.elNote.disabled = !editable;

      this.loadData(this.initData);
      this.appendToBody(this.elMain);
      this.setupHelp(this.app);
      setTimeout(() => this.show(), 1);

   }

   async save() {

      let val = new Validator([
         {
               name: 'pupilId',
               element: this.elPupilName,                
               get: () => {
                  return this.initData.pupilIds;
               },
               //validate: { 'id': true },
               error: { element: this.elMain.querySelector('.settings-item.pupil .validation-error-message'), message: "Bitte wählen Sie einen Schüler oder eine Schülerin aus." }
         },
         {
               name: 'date',
               element: this.dateSelect.getElement(),
               get: () => {
                  return this.dateSelect.getSelection();
               },
               validate: { 'date': true },
               error: { element: this.elMain.querySelector('.settings-item.date .validation-error-message'), message: "Bitte geben Sie das Datum an." }
         },
         {
               name: 'note',
               element: this.elNote,
               get: () => this.elNote.value
         }
      ]);

      let valiData = val.validate();

      if (valiData) {
         valiData.dateFrom = valiData.date.isoDate();
         valiData.dateTo   = valiData.date.isoDate();
         delete valiData.date;

         valiData.type = 'smartphoneViolation';

         let data = Object.extend(true, this.initData, valiData);

         if (!data.creatorId) data.creatorId = this.user.id;
         data.lastModifierId = this.user.id;

         for (let pupilId of data.pupilIds) {
            const saveData = Object.extend(true, data, { pupilId: pupilId });
            delete saveData.pupilIds;
            saveData.visibleForTeachers = saveData.visibleForPupils = false;
            await this.dm.saveClassNote(saveData);
         }

         //this.app.classReg.redrawBuffer();
         this.onChanged();
         this.close();

      }

   }

   delete() {

      new ModalConfirm(
         "Soll dieser Handy-Verstoß wirklich gelöscht werden?",
         async (confirmed) => {
               if (confirmed) {
                  await this.dm.deleteClassNote(this.initData);
                  //this.app.classReg.redrawBuffer();
                  this.onChanged();
                  this.close();
               }
         }
      );

   }

   setDate(from, to) {
      const elValue = this.elMain.querySelector('.settings-item.date .title .date-value');
      if (!from) elValue.innerHTML = '';
      else if (to && to.getDate() !== from.getDate()) elValue.innerHTML = Date.simplifyDatePeriod(from.isoDate(), to.isoDate());
      else elValue.innerHTML = from.toGermanDate();
   }

   setPupils(pupilIds) {

      for (let pupilId of pupilIds) {
         let pupil = this.dm.getUser(pupilId);
         if (pupil) {
            let elPupil = HTMLElement.createFromHTML(`<div class="pupil"><i class="btn-delete icon-cross"></i><div class="pupil-name">${pupil.lastName}, ${pupil.firstName}</div></div>`);
            this.elPupilName.appendChild(elPupil);
            if (!this.initData.pupilIds.includes(pupilId)) this.initData.pupilIds.push(pupilId);
            elPupil.querySelector('.btn-delete').onclick = (event) => {
               event.stopPropagation();
               this.initData.pupilIds = this.initData.pupilIds.filter(id => id !== pupilId);
               elPupil.remove();
            }
         }
      }

   }

   loadData(data) {

      if (data.creationTime) {
         const cTime = new Date(data.creationTime*1000);
         const mTime = new Date(data.lastModTime*1000);
         let info = `erstellt am ${cTime.toGermanDate(true)} um ${cTime.format("%H:%i:%s")} von ${this.app.dm.getUser(data.creatorId).short}`
         if (data.creationTime !== data.lastModTime) {
               info += `<br>zuletzt bearbeitet am ${mTime.toGermanDate(true)} um ${mTime.format("%H:%i:%s")}`;
         }
         this.elMain.querySelector('.settings-item.info').innerHTML = info;
      }

      if (data.pupilId === false) {
         if (data.classes && data.classes.length > 0) {
            let pupilIds = this.dm.getClass(data.classes[0]).pupils;
            new ModalSelectPupil({list: pupilIds}, (ids) => this.setPupils(ids), this.dm);
         }
      }
      else {
         this.setPupils(data.pupilIds);
      }

      this.dateSelect.select(data.dateFrom ? new Date(Date.fromString(data.dateFrom)) : false, data.dateTo? new Date(Date.fromString(data.dateTo)) : false);
      this.setDate(new Date(Date.fromString(data.dateFrom)), new Date(Date.fromString(data.dateTo)));
      this.elNote.value = data.note;
   }

}

